import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ObsValidationReportView } from "@/features/obs/components/ObsValidationReport";
import { useObsWizard } from "@/features/obs/hooks/obs-wizard-context";
import { getSiteUrl } from "@/lib/app-config";

/** Step 6 — read the totals, open the real screen, then publish. */
export function StepPublish() {
  const { draft, published } = useObsWizard();
  const { uploaded } = draft;

  const siteUrl = getSiteUrl();
  const previewPath = `/obs-reports/${draft.slug}`;

  if (!uploaded) return null;

  return (
    <div className="space-y-4">
      <ObsValidationReportView report={uploaded} previousStats={null} />

      {uploaded.applied && !published && (
        <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-4">
          <div className="font-semibold">عاين قبل النشر</div>
          <p className="mt-1 text-sm text-muted-foreground">
            لا توجد بيانات سابقة لهذا التقرير تُقارن بها الأرقام، لذا فحص وحدة
            القياس لا يمكنه العمل هذه المرة. افتح الشاشة وتأكّد أن الإجماليات
            بالحجم المتوقّع.
          </p>
          {siteUrl ? (
            <Button asChild variant="outline" className="mt-3">
              <a
                href={`${siteUrl}${previewPath}`}
                target="_blank"
                rel="noreferrer"
              >
                <ExternalLink className="size-4" />
                معاينة الشاشة
              </a>
            </Button>
          ) : (
            <p className="mt-3 text-sm">
              افتح على الموقع:{" "}
              <span dir="ltr" className="font-mono">
                {previewPath}
              </span>
            </p>
          )}
        </div>
      )}

      {published && (
        <div className="rounded-lg border border-emerald-500/40 bg-emerald-500/5 p-4">
          <div className="font-semibold">تم النشر</div>
          <p className="mt-1 text-sm text-muted-foreground">
            ظهر التقرير ضمن شبكة التقارير على الموقع. يمكن رفع إصدارات لاحقة من
            صفحة التقارير، وستُفحص تلقائيًا مقابل التعيين المحفوظ.
          </p>
        </div>
      )}
    </div>
  );
}
